import app from '@/main'
import store from '@/store'
import tips from '@/assets/json/errorTips'
import * as iris from '@frontend/iris'
import { sensorInit } from './sensor'

sensorInit(sensorData => {
  // 初始化 iris
  iris.init({
    /**
     * 有四种配置：
     * dev -- 开发环境
     * staging -- staging环境
     * api-test -- test环境
     * press -- 压测环境
     * prod -- 生产环境
     */
    env: CONFIG.iris,

    /**
     * 本地调试需要把domain设置为''
     * 用于储存 token 的 cookie 的域
     * 默认为 .codemao.cn
     *
     */
    // domain: process.env.NODE_ENV === 'production' ? void 0 : ''
    domain: location.href.indexOf('.codemao.cn') > -1 ? void 0 : '',
    appid: '',
    custom_headers: {
      'Sensors-Data': sensorData
    }
  })
})

const authOptions = {
  // 产品id
  pid: 'egLIJPgY',
  // 产品代号，用于数据平台分析
  product_code: 'eduexam',
  // 平台，当前业务的适用平台，用于数据平台分析
  platform: 'web',
  appid: ''
}

const captchaOptions = {
  pid: 'egLIJPgY',
  appid: ''
}

class CodemaoSDK {
  constructor() {
    if (CodemaoSDK.instance) return CodemaoSDK.instance
    this.iris = iris
    this.modulesPromise = {}
    this.getInstance('auth', authOptions)
    this.getCaptchaInstance('captcha', captchaOptions)
    CodemaoSDK.instance = this
    return this
  }
  async getInstance(module, options) {
    const { modulesPromise } = this
    return modulesPromise[module]
      ? modulesPromise[module]
      : (modulesPromise[module] = iris[module].init(options))
  }
  async getCaptchaInstance(module, options) {
    const { modulesPromise } = this
    return modulesPromise[module]
      ? modulesPromise[module]
      : (modulesPromise[module] = new iris[module].CodemaoCaptcha(options))
  }
  async moduleInit(module, options) {
    return new iris[module].CodemaoCaptcha(options)
  }
  async auth(api, ...arg) {
    const codemaoAuth = await this.getInstance('auth', authOptions)
    console.log('api', api)
    const sourceMethod = codemaoAuth[api]
    try {
      const res = await sourceMethod.call(codemaoAuth, ...arg)
      return res.data
    } catch (error) {
      console.log('error', error.error_code)
      const mapErrorCode = iris.ERROR[error.error_code] || error.error_code
      if (
        ['NO_TOKEN', 'TOKEN_INVALID', 'REFRESH_TOKEN_INVALID'].includes(mapErrorCode) &&
        (!app.$route.meta || !app.$route.meta.dialogLogin)) {
        store.commit('LOGOUT')
      }
      // 兼容证件号和报名ID登录方式，不弹tips提示
      if (api !== 'login_account_ticket' && !['NO_TOKEN', 'REFRESH_TOKEN_INVALID', 'REQUEST_ERROR', 'E_0'].includes(mapErrorCode)) {
        if (tips[mapErrorCode] === 'Network Error') {
          app.$message.error('网络异常')
        } else {
          const tip = tips[mapErrorCode] || mapErrorCode || '未知错误，重新登录或联系管理员'
          app.$message.error(tip)
        }
      }
      throw mapErrorCode
    }
  }
  async captcha(api, ...arg) {
    const codemaoCaptcha = await this.getCaptchaInstance('captcha', captchaOptions)
    const sourceMethod = codemaoCaptcha[api]
    return sourceMethod.call(codemaoCaptcha, ...arg)
  }
  /**
   * 这个方法只是一个语法糖，等同于get_captcha -> init -> show
   * @param {*} options 透传给get_captcha的参数
   */
  async verify(options = {}) {
    const captcha = await this.captcha('get_captcha', {
      ...options
    })
    await captcha.init()
    captcha.show()
  }
}

CodemaoSDK.install = function(Vue) {
  const sdk = new CodemaoSDK()
  Vue.prototype.$sdk = sdk
  Vue.prototype.$auth = sdk.auth.bind(sdk)
  Vue.prototype.$captcha = sdk.captcha.bind(sdk)
  Vue.prototype.$verify = sdk.verify.bind(sdk)
}

export default CodemaoSDK
